/**
 * 国际化配置文件
 * SC:中文
 * TC:繁体
 * EN:英文
 */
export default {
    email: { SC:"邮箱", TC: "郵箱", EN: "Email"},
    login: { SC:"登录", TC: "登錄", EN: "Sign In"},
    forgotUserID: { SC: "忘记账号", TC: "忘記賬號", EN: "Forgot User ID"},
    forgotUserIDStaff: {
      SC: "Staff members of THEi: 使用您的VTC CNA作为您的帐户ID。",
      TC: "Staff members of THEi: 使用您的VTC CNA作為您的帳戶ID。",
      EN: "Staff members of THEi: Use your VTC CNA as your account ID."
    },
    forgotUserIDStudent: {
      SC: "THEi students: 您的帐号就是您的学号。",
      TC: "THEi students: 您的帳號就是您的學號。",
      EN: "THEi students: Your account ID is your Student Number."
    },
    forgotUserIDPartner: {
      SC: "Industry Partners: 请提供与您的帐户关联的电子邮件帳號，系统会自动将您的帐户ID发送到该电子邮件地址。",
      TC: "Industry Partners: 請提供與您的帳戶關聯的電子郵件帳號，系統會自動將您的帳戶ID發送到該電子郵件地址。",
      EN: "Industry Partners: Please provide the email ID associated with your account, and the system will automatically send your account ID to that email address."
    },
    submit: { SC: "提交", TC: "提交", EN: "Submit"},
    back: { SC: "返回", TC: "返回", EN: "Back"},
    send: { SC: "发送成功", TC: "發送成功", EN: "Sent successfully."},
    emailIsNoNull: { SC:"邮箱不能为空", TC: "郵箱不能為空", EN: "Email is required." },
    emailError: { SC: "邮箱格式错误", TC: "郵箱格式錯誤", EN: "Incorrect Email format." }
  }